import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/card.css'; // Importando o CSS do Card

const Card = ({ card }) => {
  return (
    <div className="col-xl-3 col-md-6 col-sm-12 mb-4 wow fadeInUp">
      <div className="card-container position-relative">
        {/* Link invisível para tornar todo o card clicável */}
        <Link to={card.link} className="card-full-link" />

        <img
          src={card.imgSrc}
          alt={card.title}
          className="card-image"
        />
        <div className="card-content">
          <h4>
            <Link to={card.link} className="card-link">
              {card.title}
            </Link>
          </h4>
          <p className="card-description">
            {card.description}
          </p>
          <Link to={card.link} className="card-read-more">
            Leia mais <i className="fa-solid fa-arrow-right"></i>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Card;
